// frontend scripts

var REGISTRATION_TAC_END_REACHED = false;

function registrationEnableSubmitButton() {
    var isSubmitEnabled = true;
    
    if ($("#agreement_tac").is(":checked") === false) {
        isSubmitEnabled = false; 
        $("#agreement_tac").parent().find(".checkbox-custom-dummy").addClass("form-control-has-error");
    } else { 
        $("#agreement_tac").parent().find(".checkbox-custom-dummy").removeClass("form-control-has-error");
    }
    
    if ($("#agreement_tac2").is(":checked") === false) {
        isSubmitEnabled = false;   
        $("#agreement_tac2").parent().find(".checkbox-custom-dummy").addClass("form-control-has-error");
    } else { 
        $("#agreement_tac2").parent().find(".checkbox-custom-dummy").removeClass("form-control-has-error");
    } 
    
    /*
    if ($("#agreement_tac3").is(":checked") === false) {
        isSubmitEnabled = false; 
        $("#agreement_tac3").parent().find(".checkbox-custom-dummy").addClass("form-control-has-error");
    } else { 
        $("#agreement_tac3").parent().find(".checkbox-custom-dummy").removeClass("form-control-has-error");
    }
    */
    
    if ($("#agreement_gdpr1").is(":checked") === false) {
        isSubmitEnabled = false; 
        $("#agreement_gdpr1").parent().find(".checkbox-custom-dummy").addClass("form-control-has-error");
    } else { 
        $("#agreement_gdpr1").parent().find(".checkbox-custom-dummy").removeClass("form-control-has-error");
    }
    
    if (REGISTRATION_TAC_END_REACHED === false) {
        isSubmitEnabled = false; 
        $('.form-input.tac-wrapper').addClass("form-control-has-error");   
        $( ".tacScrollWrapperError" ).show();
    } else { 
        $('.form-input.tac-wrapper').removeClass("form-control-has-error"); 
        $( ".tacScrollWrapperError" ).hide();
    }       
    
    if (isSubmitEnabled === true) {    
        $( "#registration-submit-btn" ).removeClass("disabled");
    }  else {
        $( "#registration-submit-btn" ).addClass("disabled");
    }    
    return isSubmitEnabled;           
}

$( document ).ready(function() { 

  // obecne
  
  // scroll na hash anchor
  if (window.location.hash !== '') {
      var scrollToElem = $('#' + window.location.hash.replace('#', ''));
      if(scrollToElem) {
          $([document.documentElement, document.body]).animate({
              scrollTop: scrollToElem.offset().top
          }, 500);
      }  
  }


  // registrace  
  $('.tacScrollWrapper').scrollbar();  	
  
  $( ".tacScrollWrapper" ).scroll(function() {  
        if($(this).scrollTop() + $(this).innerHeight() >= $(this)[0].scrollHeight - 1500) {
            REGISTRATION_TAC_END_REACHED = true;      
            registrationEnableSubmitButton();
        }
  });
  
  $( "#agreement_tac, #agreement_tac2, #agreement_tac3, #agreement_gdpr1, #agreement_gdpr2, #agreement_gdpr3" ).change(function() {
    registrationEnableSubmitButton();
  });
  
  $( "#registration-submit-btn" ).click(function() {
      if ( registrationEnableSubmitButton() === false ) {
          return false;
      }    
  });
  
    $('.slider').show().slick({
        dots: true,
        infinite: true,
        speed: 500,
        fade: true,
        cssEase: 'linear',
        autoplay: true,
        autoplaySpeed: 2000,
    });

    /*
    var fancyboxSetting = {
        openEffect: 'elastic',
        closeEffect: 'elastic',
        closeBtn: false,
        helpers: {
            title: {
                type: 'inside'
            },
            thumbs: {
                width: 50,
                height: 50
            },
            buttons: {},
            overlay: {
                locked: false
            }
        }
    };

    $('.fancybox:not(.cycle-sentinel .fancybox)').fancybox(fancyboxSetting);
    */
     
});